import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["translator", "assetPath", "locale", "backLink"];
import * as React from 'react';
import { Button } from '@gandi/ui';
import { Static } from '../Static';
import { getSupportEmail } from '../../lib/email';
function Error(_ref) {
  var __ = _ref.translator.__,
    assetPath = _ref.assetPath,
    locale = _ref.locale,
    backLink = _ref.backLink,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Static, _extends({
      title: __('500 - Application Error'),
      illustration: assetPath('img/Error.svg'),
      buttons: backLink && /*#__PURE__*/React.createElement(Button, {
        href: backLink
      }, __('Return to homepage'))
    }, extraProps), /*#__PURE__*/React.createElement("p", null, __('An error has occurred and the operation could not be completed.')), /*#__PURE__*/React.createElement("p", null, __('Please try again at a later moment.')), /*#__PURE__*/React.createElement("p", {
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML: __('If the error persists, please ' + '<a href="mailto:%(support_email)s">contact Customer Care</a> ' + 'and provide details about the action you tried to perform.', {
        withHTML: true,
        support_email: getSupportEmail(locale)
      })
    }))
  );
}
export default Error;